var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeftAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 296,
    viewBox: "0 0 247 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.71426,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.71426,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.71426,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.71426,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5715,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7142,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 122.712,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 150.141,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 175.855,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5714,
    cy: 203.284,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-35.0125 92.1768C-2.6677 90.1899 73.9493 70.4095 97.8313 143.151C122.158 217.246 206.942 216.966 239.392 203.785",
    stroke: "#DDE6FD",
    strokeWidth: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftAgenda);
export default __webpack_public_path__ + "static/media/bottom_left_agenda.ce20e808b73d8ba31f780183b51574a6.svg";
export { ForwardRef as ReactComponent };